<template>
  <main>
    <HeaderMain type="" :single="true" />

    <section class="c-section c-section--checkout py-4 py-lg-5">
      <div class="c-container">
        <header class="d-flex justify-content-between mb-4 px-2 px-md-0">
          <div class="c-breadcumb d-flex align-items-center">
            <div
              class="c-breadcumb__item d-flex align-items-center"
              :class="{'completed' : step >= 1}">
              <span>1</span>
              <span class="w-sbold">Proceso de pago</span>
            </div>
            <template>
              <span class="mx-2 d-flex justify-content-center align-items-center">
                <i class="iconf-arrow-right d-flex align-items-center fs-14 mr-2"></i>
              </span>
              <div
                class="c-breadcumb__item d-flex align-items-center"
                :class="{'completed' : step == 2}">
                <span>2</span>
                <span class="w-sbold">
                  {{(userData && userData.id) ? 'Resumen' : 'Activación'}}
                </span>
              </div>
            </template>
          </div>
          <p class="mb-0 d-none d-md-flex align-items-center darks">
            <i class="iconf-lock d-flex align-items-center fs-18"></i>
            <span class="ms-2 w-sbold">Compra 100% segura</span>
          </p>
        </header>

        <div class="row justify-content-center">
          <div class="col col-12 col-lg-6 order-2 order-lg-1">
            <transition name="fade" mode="out-in">
              <router-view keep-alive />
            </transition>

            <PaymentDetails
              v-if="step != 2 && device == 'mobile'"
              class="mt-4"
            >
            </PaymentDetails>

            <p class="mb-0 w-medium d-inline-block mt-4 text-center w-100">
              ¿Necesitas ayuda?
              <a :href="whatsappLink" class="c-link" target="_blank">Contáctanos</a>
            </p>
          </div>
          <div class="col col-12 col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0">
            <OrderSummary :step="step" />

            <PaymentDetails
              v-if="step != 2 && device == 'desktop'"
              class="mt-4">
            </PaymentDetails>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      arcux: { ...window.arcux },
      step: 1,

      device: '',
    };
  },
  watch: {
    $route() {
      this.initStep();
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
      country: (state) => state.checkout.country,
      paymentMethod: (state) => state.checkout.paymentMethod,
      product: (state) => state.checkout.product,
      price: (state) => state.checkout.price,
      // coupon: (state) => state.checkout.coupon,
    }),
    isTrialPlan() {
      return (this.$route.query.plan.search('trial') >= 0 || this.$route.query.plan.search('gratis') >= 0);
    },
    whatsappLink() {
      return `https://api.whatsapp.com/send?phone=${this.arcux.project.phone}&text=Hola, tengo una cosulta sobre...`;
    },
  },
  mounted() {
    const breakpoint = window.matchMedia('(min-width: 1024px)');

    this.initStep();
    this.checkDevice(breakpoint); breakpoint.addListener(this.checkDevice);
  },
  components: {
    HeaderMain: () => import(/* webpackChunkName: "header-main" */'../components/Header.vue'),
    PaymentDetails: () => import(/* webpackChunkName: "checkout-details" */'../components/checkout/PaymentDetails.vue'),
    OrderSummary: () => import(/* webpackChunkName: "checkout-order-summary" */'../components/checkout/OrderSummary.vue'),
  },
  methods: {
    initStep() {
      if (this.$route.name === 'Checkout Payment') {
        this.step = 1;
      } else if (this.$route.name === 'Checkout Order') {
        this.step = 2;
      }
    },
    checkDevice(breakpoint) {
      if (breakpoint.matches) {
        this.device = 'desktop';
      } else {
        this.device = 'mobile';
      }
    },
  },
};
</script>
